import React from "react";

const Bash_Variables = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Variables</h2>
      <p>Variables: assignment without spaces. To read use <code>$VAR</code>.</p><pre><code>NAME="Abhi"
echo "Hi, $NAME"</code></pre>
    </div>
  );
};

export default Bash_Variables;
